import { createSelector } from 'reselect'

export const getEndgame = (state) => state.mars.endGame

export const report = createSelector([getEndgame], (endGame) => endGame.report)
